/* A browser retains a bookmarked fragment across the server's login redirect.
 * Move that app route into Frappe's normal post-authentication destination.
 * Never change an explicit document destination, recovery hash or external URL.
 */
(() => {
  const url = new URL(location.href);
  const route = url.hash.slice(1);
  if (url.pathname !== '/login' || url.searchParams.get('redirect-to') !== '/erp'
      || !route || ['login', 'signup', 'forgot', 'email', 'steptwo', 'login_with_email_link'].includes(route)) return;
  url.searchParams.set('redirect-to', '/erp#' + route);
  url.hash = '';
  history.replaceState(null, '', url);
})();
